<template>
  <div class="lby-uploaded-images">
    <div class="lby-uploaded-image" @click="zoomIn" >
        <img :src="src" ref="me"  @load="loadImage" class="loading"/>
        <div class="lby-uploaded-image-del" @click.stop="delImage(src)" v-if="showDel"></div>
    </div>
  </div>
</template>

<script>
import { deleteImage } from '@/api/file/index'
import blank from '@/assets/styles/blank.svg'
export default {
  name: 'ShowImage',
  props: {
    src: {
      type: String,
      required: true
    },
    showDel: {
      type: Boolean,
      default: true
    },
    goodsId: {
      type: String
    }
  },
  data () {
    return {
      windowWidth: window.innerWidth + 'px',
      windowHeight: window.innerHeight + 'px',
      zoom: false,
      scrollToY: 0,
      ifShow: false,
      blank
    }
  },
  methods: {
    loadImage () {
      // 只有src是非blank时，图片才进行替换，如果是blank，那么就啥也不做，直接显示就行了
      if (this.src.indexOf('blank') === -1) { // 这是一个要加载的图片，那么当加载完成以后，需要完成替换
        this.$refs.me.classList.remove('loading')
      }
    },
    zoomIn (e) {
      if (!this.zoom) {
        this.scrollToY = e.pageY
        e.target.style.position = 'fixed'
        e.target.style.top = 0
        e.target.style.left = 0
        e.target.style.width = this.windowWidth
        e.target.style.height = this.windowHeight
        e.target.style['z-index'] = 999
        e.target.style.margin = 0
        document.body.style.overflow = 'hidden'
        document.body.style.height = '500px'
      } else {
        e.target.style.position = null
        e.target.style.top = null
        e.target.style.left = null
        e.target.style['margin-top'] = '10px'
        e.target.style.width = '1080px'
        e.target.style.height = 'auto'
        document.body.style.height = 'auto'
        window.scrollTo(0, this.scrollToY - 200)
      }
      this.zoom = !this.zoom
    },
    delImage (src) {
      this.$messageBox.confirm('是否删除图片?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showCancelButton: true,
        type: 'warning'
      }).then(async () => {
        const res = await deleteImage(src, this.goodsId)
        this.$emit('changeUploadedList', res.data)
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消'
        })
      })
    },
    handleResize () {
      this.windowWidth = window.innerWidth + 'px'
      this.windowHeight = window.innerHeight + 'px'
      if (this.zoom) {
        this.$refs.me.style.width = this.windowWidth
        this.$refs.me.style.height = this.windowHeight
      }
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    document.body.style.overflow = null
    document.body.style.height = 'auto'
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style scoped lang="less">
.lby-uploaded-images{
    .loading{
      width: 1080px;
      height: 500px;
      background-color: rgb(230, 230, 230);
      border: 3px solid rgb(121, 120, 120);
    }
    img{
      margin-top: 10px;
      width: 100%;
      height: auto;
    }
    .lby-uploaded-image{
      position: relative;
      .lby-uploaded-image-del{
        position: absolute;
        top: 10px;
        right: 0px;
        background-color: rgba(0, 0, 0, 0.5);
        width: 100px;
        height: 100px;
        z-index: 909;
        display: none;
      }
      .lby-uploaded-image-del::before, .lby-uploaded-image-del::after {
        content: '';
        position: absolute;
        width: 100%;
        height: 3px; /* 线的粗细 */
        background-color: rgb(250, 2, 2); /* 线的颜色 */
        top: 50%;
        left: 0;
      }

      .lby-uploaded-image-del::before {
        transform: rotate(45deg); /* 旋转45度 */
      }

      .lby-uploaded-image-del::after {
        transform: rotate(-45deg); /* 旋转-45度 */
      }
    }

    .lby-uploaded-image:hover{
      .lby-uploaded-image-del{
        display: block;
        cursor: pointer;
      }
    }
  }
</style>
